import React from 'react';
import { Skeleton, useSlider } from '@fourthwall/components';
import { ChevronLeftIcon, ChevronRightIcon } from '@fourthwall/icons';
import * as Carousel from './components/Carousel/Carousel';
import { AbandonmentDiscountSlide } from './modules/AbandonmentDiscountSlide/AbandonmentDiscountSlide';
import { ClaimFreeDomainSlide } from './modules/ClaimFreeDomainSlide/ClaimFreeDomainSlide';
import { FreeShippingSlide } from './modules/FreeShippingSlide/FreeShippingSlide';
import { OrdersToSendSlide } from './modules/OrdersToSendSlide/OrdersToSendSlide';
import { ThankSupportersSlide } from './modules/ThankYousSlide/ThankYousSlide';
import { TwitchGiftingSlide } from './modules/TwitchGiftingSlide/TwitchGiftingSlide';
import { YTShelfSlide } from './modules/YTShelfSlide/YTShelfSlide';
export const MiniRecommendations = ({ data, page = 'home' }) => {
    const { getContainerProps, getSliderProps, getSlideProps, getPrevButtonProps, getNextButtonProps, dataRole, resetSlider, } = useSlider();
    const slideProps = {
        ...getSlideProps(),
        data,
        resetSlider,
    };
    return (React.createElement(Carousel.Root, { id: "carousel-root", "data-analytics": "mini-recommendations-container", ...getContainerProps(), sliderDataRole: dataRole, "data-empty": getContainerProps().$slidesCount === 0 ? 'true' : 'false' },
        React.createElement(Carousel.ItemGradient, { side: "right", isVisible: !getPrevButtonProps().disabled }),
        React.createElement(Carousel.NavButton, { direction: "left", isVisible: !getPrevButtonProps().disabled, ...getPrevButtonProps() },
            React.createElement(ChevronLeftIcon, { width: 18 })),
        React.createElement(Carousel.Slider, { ...getSliderProps() },
            page === 'home' && (React.createElement(React.Fragment, null,
                React.createElement(OrdersToSendSlide, { ...slideProps }),
                React.createElement(FreeShippingSlide, { ...slideProps }),
                React.createElement(YTShelfSlide, { ...slideProps }),
                React.createElement(ThankSupportersSlide, { ...slideProps }),
                React.createElement(TwitchGiftingSlide, { ...slideProps }),
                React.createElement(AbandonmentDiscountSlide, { ...slideProps }),
                React.createElement(ClaimFreeDomainSlide, { ...slideProps }))),
            page === 'orders' && (React.createElement(React.Fragment, null,
                React.createElement(OrdersToSendSlide, { ...slideProps }),
                React.createElement(FreeShippingSlide, { ...slideProps }),
                React.createElement(ThankSupportersSlide, { ...slideProps }),
                React.createElement(YTShelfSlide, { ...slideProps }),
                React.createElement(TwitchGiftingSlide, { ...slideProps }),
                React.createElement(AbandonmentDiscountSlide, { ...slideProps }),
                React.createElement(ClaimFreeDomainSlide, { ...slideProps }))),
            page === 'promotions' && (React.createElement(React.Fragment, null,
                React.createElement(FreeShippingSlide, { ...slideProps }),
                React.createElement(AbandonmentDiscountSlide, { ...slideProps }),
                React.createElement(YTShelfSlide, { ...slideProps }),
                React.createElement(OrdersToSendSlide, { ...slideProps }),
                React.createElement(TwitchGiftingSlide, { ...slideProps }),
                React.createElement(ThankSupportersSlide, { ...slideProps }),
                React.createElement(ClaimFreeDomainSlide, { ...slideProps })))),
        React.createElement(Carousel.ItemGradient, { side: "left", isVisible: !getNextButtonProps().disabled }),
        React.createElement(Carousel.NavButton, { direction: "right", isVisible: !getNextButtonProps().disabled, ...getNextButtonProps() },
            React.createElement(ChevronRightIcon, { width: 18 }))));
};
export const MiniRecommendationsSkeleton = () => {
    return (React.createElement(Carousel.Root, { "$slidesCount": 3 },
        React.createElement("div", { style: { width: '100%' } },
            React.createElement("div", { style: { width: '100%', display: 'flex', gap: 'var(--space-400)' } },
                React.createElement(Skeleton.Shape, { width: "33%", height: "36px", radius: "var(--radius-brand)" }),
                React.createElement(Skeleton.Shape, { width: "33%", height: "36px", radius: "var(--radius-brand)" }),
                React.createElement(Skeleton.Shape, { width: "33%", height: "36px", radius: "var(--radius-brand)" })))));
};
